import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import SelectEmpresa from './SelectEmpresa';
import SelectPeriodo from './SelectPeriodo';
import SeleccionEmpleados from './SeleccionEmpleados';
import { obtenerlistaperiodo, obtenerlistadepta } from '../../../Redux/DepartamentosDucks'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack';
import moment from 'moment';
import SelectDepartamento from './SelectDepartamento';
import { obtenerincidenciasxlotes } from '../../../Redux/LotesDucks';
import { Grid } from '@mui/material';
import useSubmitLock from '../../../hooks/useSubmitLock';
const { REACT_APP_API_URL } = process.env;

const steps = ['- Empresa', '- Departamento', '- Periodo', '- Empleado '];

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <div>{children}</div>
                </Box>
            )}

        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};


export default function AltaIncidencias() {
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar();
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const [value, setValue] = React.useState(0);
    const [bd, setBd] = React.useState('');
    const [dep, setDep] = React.useState([]);
    const [periodo, setPeriodo] = React.useState('');
    const [lote, SetLote] = React.useState('');
    const { submitting, runWithSubmitLock } = useSubmitLock();


    const fechainicial = new Date(periodo.fechainicio)
    fechainicial.setDate(fechainicial.getDate() + 1)

    const fechafinal = new Date(periodo.fechafin)
    fechafinal.setDate(fechafinal.getDate() + 1)


    const fechainicio = moment(fechainicial).format('YYYY-MM-DD');
    const fechafin = moment(fechafinal).format('YYYY-MM-DD');


    const ejercicio = new Date().getFullYear()

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = (newValue) => {
        const dato = newValue + 1
        let newSkipped = skipped;

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped)
        setValue(dato);
    };
    const handleNext0 = (v) => {

        setActiveStep(v);
        setValue(v);

        switch (v) {
            case 1:
                dispatch(obtenerlistadepta(bd))
                break;
            case 2:
                dispatch(obtenerlistaperiodo(bd, ejercicio))
                break;
            default:
                break;
        }
    };

    const obtenerincidenciasporlotes = (lote) => {
        dispatch(obtenerincidenciasxlotes(lote))
    }

    const handleBack = (newValue) => {
        const dato = newValue - 1
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        setValue(dato);
    };

    const obtenerBDhijo = (bd) => {
        setBd(bd)
    }
    const obtenerDeptahijo = (depta) => {
        setDep(depta)

    }
    const obtenerPeriodohijo = (p) => {
        setPeriodo(p)
    }

    const handleClickVariant = (resultado) => {
        const idlote = resultado.idlote
        const variant = resultado.variant
        const success = resultado.success
        const msg = resultado.errores || resultado.msg
        enqueueSnackbar(msg, { variant });

        if (success === false) {
            setActiveStep(0);
            setValue(0)
        } else {
            SetLote(idlote)
            obtenerincidenciasporlotes(idlote)
            handleNext(2)
        }
    };

    const agregarLote = () => runWithSubmitLock(async () => {
        const iddepartamento = dep.iddepartamento;
        const descdepto = dep.descripcion;
        const idperiodo = periodo.idperiodo;
        const numeroperiodo = periodo.numeroperiodo;
        const ejercico = periodo.ejercicio;
        const result = {
            'variant': 'error',
            'success': 'error',
            'msg': 'El campo esta vacio perido, departamento o empresa'
        }

        if (periodo === '' || dep === '' || bd === '') {
            handleClickVariant(result)
            setActiveStep(2);
            setValue(2)
        } else {
            const token = sessionStorage.getItem('%t')
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${token}`);
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                "guidempresa": bd,
                "iddepartamento": iddepartamento,
                "descdepto": descdepto,
                "idperiodo": idperiodo,
                "numeroperiodo": numeroperiodo,
                "fechainicio": fechainicio,
                "fechafin": fechafin,
                "ejercicio": ejercico
            });
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };
            try {
                const response = await fetch(`${REACT_APP_API_URL}/lotes`, requestOptions,);
                const resultado = await response.json();
                return (handleClickVariant(resultado))

            } catch (error) {
                console.log("Algo salio mal", error);
            }
        }
    })

    return (
        <Box sx={{ width: '100%' }} padding='12px'>
            <Grid container justifyContent='center'>
                <Grid >
                    <Stepper activeStep={activeStep}>
                        {steps.map((label, index) => {
                            const stepProps = {};
                            const labelProps = {};

                            if (isStepSkipped(index)) {
                                stepProps.completed = false;
                            }
                            return (
                                <Step key={label} {...stepProps} >
                                    <StepLabel {...labelProps}>{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                </Grid>
            </Grid>

            <TabPanel value={value} index={0}>
                <SelectEmpresa
                    obtenerBDhijo={obtenerBDhijo}
                    obtenerDeptahijo={obtenerDeptahijo}
                    bd={bd}
                    dep={dep}
                />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <SelectDepartamento
                    obtenerBDhijo={obtenerBDhijo}
                    obtenerDeptahijo={obtenerDeptahijo}
                    bd={bd}
                    dep={dep}
                />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <SelectPeriodo
                    obtenerPeriodohijo={obtenerPeriodohijo}
                    periodo={periodo}
                    ejercicio={ejercicio}
                    bd={bd}
                />

            </TabPanel>
            <TabPanel value={value} index={3}>
                <SeleccionEmpleados
                    lote={lote}
                    bd={bd}
                    depta={dep}
                    periodo={periodo}
                    obtenerincidenciasxlote={obtenerincidenciasporlotes}
                    obtenerdatolote={obtenerincidenciasporlotes}
                />
            </TabPanel>
            {activeStep === steps.length ? (
                <>

                </>
            ) : (
                <>

                    <Box sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center', flexDirection: 'row', pt: 3, width: '100%' }}>
                        {activeStep === 3 ? null : <Button
                            variant='contained' color='success'
                            disabled={activeStep === 0}
                            onClick={() => handleBack(value)}
                            sx={{ mr: 28 }}
                        >
                            Atras
                        </Button>}


                        <Box />

                        {activeStep === 2 ? (
                            <>
                                <Button
                                    disabled={submitting}
                                    onClick={() => agregarLote()} variant='contained' color='success'>
                                    Crear lote
                                </Button>
                            </>
                        ) : null
                        }

                        {activeStep === 0 ? (
                            <>
                                <Button
                                    onClick={() => handleNext0(1)} variant='contained' color='success'>
                                    Siguiente
                                </Button>
                            </>
                        ) : null
                        }

                        {activeStep === 1 ? (
                            <>
                                <Button
                                    onClick={() => handleNext0(2)} variant='contained' color='success'>
                                    Siguiente
                                </Button>
                            </>
                        ) : null
                        }
                    </Box>
                </>
            )}
        </Box>
    );
}